import { Component } from '@angular/core';

import {OpcaoConfirmacao} from './opcao-confirmacao-model'
import {SituacaoConfirmacaoService} from './situacao-confirmacao.service'
/**
 * Componente exibido no modal
 */
@Component({
  selector: 'confirmacao-modal-component',
  styleUrls: ['./confirmacao-modal.component.scss'],
  templateUrl: './confirmacao-modal.component.html',
})
export class ConfirmacaoModalComponent 
{
  opcoes: OpcaoConfirmacao;

  constructor(private state: SituacaoConfirmacaoService) 
  {
    this.opcoes = state.opcoes;
  }

  sim() 
  {
    this.state.modal.close('confirmado');
  }

  nao() 
  {
    this.state.modal.dismiss('não confirmado');
  }
}
